  <template>
  <div style="overflow-x: auto">
    <div id="app">
      <ConfirmModal></ConfirmModal>

      <!--      <v-app v-if="getCookie__c('session_login')">-->
      <v-app>
        <SideMenu v-if="$route.name !== 'Home'" class="to-hide"></SideMenu>

        <v-main style="background: var(--main-bg-color)" id="main">
          <Header v-if="$route.name !== 'Home'" class="to-hide"></Header>

          <v-divider class="to-hide"></v-divider>

          <v-container fluid :class="{ 'px-6 py-4': $route.name !== 'Home' }">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </v-container>
        </v-main>

        <div v-if="$route.name !== 'Home'" class="footer-stripe to-hide">
          <v-img
              eager
              :src="require('./assets/watermark-logo.png')"
              min-width="116"
              max-width="116"
              class="watermark-pos"
              aspect-ratio="1"
          ></v-img>
        </div>

        <v-footer
            v-if="$route.name !== 'Home'"
            color="var(--main-bg-color)"
            class="footer-div d-flex align-self-end to-hide"
            min-height="var(--footer-height)"
        >
          <v-layout justify-space-between class="txt-mini footer-text">
            <v-flex shrink>
              © 2023 ALL RIGHTS RESERVED
            </v-flex>
            <v-flex shrink>
              111 ถนนมหาวิทยาลัย ตำบลสุรนารี อำเภอเมือง จังหวัดนครราชสีมา 30000 โทรศัพท์ <span class="theme-color-one">0-4422-3000</span>
              โทรสาร <span class="theme-color-one">0-4422-4070</span>
            </v-flex>
          </v-layout>
        </v-footer>
        <ScrollProgressBar v-if="shouldShowScrollProgress" />
      </v-app>

      <!--      <v-app v-else>-->
      <!--        <router-view></router-view>-->
      <!--      </v-app>-->
    </div>
  </div>
</template>

<script>
import Header from "./components/Header"
import SideMenu from "./components/SideMenu"
import ConfirmModal from "./components/ConfirmModal"
import {getCookie__c} from "./plugins/cookies"
import ScrollProgressBar from "./components/ScrollProgressBar.vue";

export default {
  components: {
    Header,
    SideMenu,
    ConfirmModal,
    ScrollProgressBar
  },
  data() {
    return {
      getCookie__c
    }
  },
  created () {
    this.$store.commit('General/clearModal')
    this.$store.commit('General/setLoading', false)
  },
  methods: {
    async getUser() {
      let user = await this.$apiFire('Auth/getUser')
    }
  },
  computed: {
    shouldShowScrollProgress() {
      return this.$route.meta?.showScrollProgress === true;
    }
  }
}
</script>

<style>
#app {
  font-family: 'ChulabhornLikit', sans-serif;
  min-width: var(--screen-min-width);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.footer-div {
  width: calc(100% - var(--drawer-width));
  border-top: solid 1px var(--theme-color-nine) !important;
}

.footer-stripe {
  background: var(--main-bg-color);
  height: 55px;
}

.watermark-pos {
  position: absolute;
  right: 0;
  z-index: 2;
  bottom: 0;
}
</style>
